export function initFullScreenToggle() {
  if ($("#full-screen-toggle").length === 0) return;

  const CLASSES = {
    D_NONE: 'd-none',
    D_LG_BLOCK: 'd-lg-block',
    COL_LG_9_XL_10: 'col-lg-9 col-xl-10',
    FA_EXPAND: 'fa-expand-arrows-alt',
    FA_COMPRESS: 'fa-compress-arrows-alt'
  };

  const MARGINS = {
    FULL_SCREEN: '0px 0px',
    NORMAL: '0px 0'
  };

  const TABLE_HEIGHT_OFFSETS = {
    FULL_SCREEN: 230,
    NORMAL: 400
  };

  function isFullScreen(): boolean {
    return !$('.sidebar-column').hasClass(CLASSES.D_LG_BLOCK);
  }

  function setTableWrapperHeight(offset: number): void {
    $('.table-wrapper').css('max-height', `${window.innerHeight - offset}px`);
  }

  function enterFullScreen(): void {
    $('.sidebar-column').removeClass(CLASSES.D_LG_BLOCK).addClass(CLASSES.D_NONE);
    $('.main-content-column').removeClass(CLASSES.COL_LG_9_XL_10);
    $('#full-screen-toggle i').removeClass(CLASSES.FA_EXPAND).addClass(CLASSES.FA_COMPRESS);
    $('.app').css('margin', MARGINS.FULL_SCREEN);
    $('#customer-success-stats').addClass(CLASSES.D_NONE);
    $('#customer-content').addClass('cs-fullscreen');
    setTableWrapperHeight(TABLE_HEIGHT_OFFSETS.FULL_SCREEN);
    $('#full_screen').val('true');
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('full_screen', 'true');
      history.replaceState(null, '', url.pathname + url.search);
    }
  }

  function exitFullScreen(): void {
    $('.sidebar-column').removeClass(CLASSES.D_NONE).addClass(CLASSES.D_LG_BLOCK);
    $('.main-content-column').addClass(CLASSES.COL_LG_9_XL_10);
    $('#full-screen-toggle i').removeClass(CLASSES.FA_COMPRESS).addClass(CLASSES.FA_EXPAND);
    $('.app').css('margin', MARGINS.NORMAL);
    $('#customer-content').removeClass('cs-fullscreen');
    if (window.location.pathname == "/customer_success/customers" || window.location.pathname == "/customer_success/my_clients") {
      $('#customer-success-stats').removeClass(CLASSES.D_NONE);
    }
    setTableWrapperHeight(TABLE_HEIGHT_OFFSETS.NORMAL);
    $('#full_screen').val('false');
    if (history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.delete('full_screen');
      history.replaceState(null, '', url.pathname + url.search);
    }
  }

  function toggleFullScreen(): void {
    if (isFullScreen()) {
      exitFullScreen();
    } else {
      enterFullScreen();
    }
  }

  function debounce(func: Function, wait: number) {
    let timeout: any;
    return function (...args: any[]) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  const debouncedToggle = debounce((e: Event) => {
    toggleFullScreen();
  }, 250);

  $("#full-screen-toggle").off("click.fullscreen").on("click.fullscreen", function (e: Event) {
    e.preventDefault();
    debouncedToggle(e);
  });

  $(document).off("keydown.fullscreen").on("keydown.fullscreen", function (e: JQuery.TriggeredEvent) {
    if (e.key === "Escape" && isFullScreen()) {
      exitFullScreen();
    }
  });

  const urlParams = new URLSearchParams(window.location.search);
  const isFullScreenParam = urlParams.get('full_screen') === 'true';
  const isFullScreenHidden = $('#full_screen').val() === 'true';

  if (isFullScreenParam || isFullScreenHidden) {
    enterFullScreen();
  }
}
